import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { get, ImageUrl } from '../../ApiServices/ApiServices';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from "moment";
import { Image } from 'antd';
import { useSelector } from 'react-redux';

function WeddingOrderReview() {

    const [data, setdata] = useState([]);
    const [address, setaddress] = useState('')
    // Handler for checkbox change
    const [selectedAddress, setSelectedAddress] = useState('');
    const location = useLocation()
    const navigate = useNavigate()
    const { id } = useParams();
    const shirtSize = useSelector((state) => state.profile.shirtSize);

    const ViewSingleorder = async () => {
        try {
            const firstApi = `view-single-order/${id}`;
            const firstResponse = await get(firstApi);

            if (firstResponse?.status == true) {
                setdata(firstResponse?.data);

                // if (firstResponse?.data?.store_id) {
                //     try {
                //         // alert("alert 1"); // Your alert is working

                //         const secondApi = `all-group-customers/${firstResponse.data.store_id}`;
                //         const secondResponse = await get(secondApi);
                //         alert("alert 2"); // Your alert is working

                //         if (secondResponse?.status === true) {
                //             console.log(secondResponse.data, "response.data");
                //             // setaddress(response.data);
                //         }


                //         if (secondResponse?.status === true) {
                //             // setaddress(secondResponse.data);
                //         }
                //     } catch (err) {
                //         console.error('Error in second API call:', err);
                //     }
                // }
            }
        } catch (err) {
            console.error('Error in first API call:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    console.log(data?.store_id, "datadatadatadatadata");
    useEffect(() => {
        if (id) {
            ViewSingleorder();
        }
    }, [id])

    const { single_order_style = [] } = data;

    const coat = single_order_style.find(item => item.inventory_category_type === "Coats");
    const pant = single_order_style.find(item => item.inventory_category_type === "Pants");
    const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt");
    const vest = single_order_style.find(item => item.inventory_category_type === "Vests");
    const tie = single_order_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes");
    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content"
                                    ><h3 class="nk-block-title page-title">Active Wedding Events</h3></div>
                                    <div class="nk-block-head-content">
                                        <div class="toggle-wrap nk-block-tools-toggle">
                                            <div class="toggle-expand-content" data-content="pageMenu">
                                                <ul class="nk-block-tools g-3">
                                                    <li class="nk-block-tools-opt">
                                                        <a href="" data-bs-toggle="modal" data-bs-target="#instructionModal" class="btn btn-primary"><span>Add Member</span></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card card-full orderReviewNwUpdate">
                                <div class="card-inner">
                                    <div class="card-title-group mb-4">
                                        <div class="card-tools">
                                            <div class="form-control-wrap dateBoxWithBtn">
                                                <div className="ordeDateButton groomBride">
                                                    <h5 class="mb-0">
                                                        <img src="assets/images/groom.svg" alt="" width="30" />
                                                        <span>Groom Name <small>Nirmal</small></span>
                                                    </h5>
                                                    <h5 class="mb-0">
                                                        <img src="assets/images/bride.svg" alt="" width="30" />
                                                        <span>Bride Name <small>Not Found</small></span>
                                                    </h5>
                                                </div>
                                            </div>

                                            <div class="form-control-wrap">
                                                {/* <h5 class="mb-0">Event Date: {moment(data?.event_date).format("MMM D, YYYY")}</h5> */}
                                                <p className="mb-1">Order date: {moment(data?.createdAt).format("MMM D, YYYY")}</p>
                                                <p>Event Date: {data?.order_type}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-tools mb-3">
                                        <div class="form-control-wrap">
                                            <h6 class="mb-0 orderStatusDiv">Groom style</h6>
                                        </div>
                                    </div>




                                    <div className="row">
                                        <div className="col-md-4 order-md-2">
                                            <div className="eventDetailBox">
                                                <div className="firstTitle">
                                                    <p>Customer </p>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <p><em class="icon ni ni-user-alt"></em> {data?.first_name} {data?.last_name}</p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <p><em class="icon ni ni-bag"></em> {data?.phone ? data?.phone : "N/A"}</p>
                                                                <p><em class="icon ni ni-bag"></em> {data?.email ? data?.email : "N/A"}</p>                                                              </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <hr></hr>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <p className="mb-1"><b>Submitted by:</b> {data?.measured_by ? data?.measured_by : "N/A"}</p>
                                                            {/* <p className="mb-1"><b>Customer slip name:</b> {data?.first_name} {data?.last_name}</p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="eventDetailBox">
                                                <div className="firstTitle">
                                                    <p>Contact Information</p>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    {/* <em className={`icon ni ${data?.user?.account ? "ni-user-alt" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em> */}
                                                                    Acct: {data?.user?.account ? data.user.account : "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    Account Name: {data?.user?.companyName ? data.user.companyName : "N/A"}
                                                                    {/* <em className={`icon ni ${data?.user?.companyName ? "ni-building" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em> */}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    {/* <em className={`icon ni ${data?.user?.firstName ? "ni-smile" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em> */}
                                                                    Owner: {data?.user?.firstName ? `${data.user.firstName} ${data.user.lastName}` : "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <em className={`icon ni ${data?.user?.email ? "ni-user-alt" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                    {data?.user?.email ? data.user.email : "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <em className={`icon ni ${data?.user?.phone ? "ni-call" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                    {data?.user?.phone ? data.user.phone : "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {data?.is_alt_pickup_enable === true ? (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Alternate Pickup Location</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <p><em className="icon ni ni-user-alt"></em> {data?.affiliatedStore?.firstName || ""} {data?.affiliatedStore?.lastName || ""}</p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p> <em class="icon ni ni-map-pin"></em>
                                                                        {data?.affiliatedStore?.addresses[0]?.billingAddress}
                                                                        {data?.affiliatedStore?.addresses[0]?.billingAddressLine2 && `, ${data.affiliatedStore.addresses[0].billingAddressLine2}`}
                                                                        {(data?.affiliatedStore?.addresses[0]?.billingCity || data?.affiliatedStore?.addresses[0]?.billingState) && ', '}
                                                                        {[data?.affiliatedStore?.addresses[0]?.billingCity, data?.affiliatedStore?.addresses[0]?.billingState].filter(Boolean).join(', ')}
                                                                        {data?.affiliatedStore?.addresses[0]?.billingZip && `, ${data.affiliatedStore.addresses[0].billingZip}`}
                                                                    </p>                                                                    </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : data?.is_drop_ship_enable === true ? (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Drop Shipping</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <p><em class="icon ni ni-user-alt"></em> {data?.name ? data?.name : ""}</p>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <p><em class="icon ni ni-call"></em>{data?.shipping_phone ? data?.shipping_phone : ""}</p>
                                                                </div>
                                                                <div className="col-md-12 mt-2">
                                                                    <p>
                                                                        <em class="icon ni ni-map-pin"></em> {data
                                                                            ? `${data.shipping_address || ""}, ${data.shipping_city || ""}, ${data.shipping_state || ""} ${data.shipping_zip || ""}`
                                                                            : ""}
                                                                    </p>                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ) : (
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Shipping address</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <p><em className="icon ni ni-user-alt"></em> {data?.user?.firstName || ""} {data?.user?.lastName || ""}</p>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <p>
                                                                        <em class="icon ni ni-map-pin"></em>  {data ? `${data.user?.addresses[0]?.billingAddress || ""}, ${data.user?.addresses[0]?.billingAddressLine2 || ""}, ${data.user?.addresses[0]?.billingCity || ""}, ${data.user?.addresses[0]?.billingState || ""}, ${data.user?.addresses[0]?.billingZip || ""}` : ""}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            <div className="eventDetailBox">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <h5 className="mb-0">Comment</h5>
                                                                <p>{data?.comments ? data?.comments : "N/A"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-8 order-md-1">
                                            {
                                                coat &&
                                                <div className="eventDetailBox posRealtive">

                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={coat?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${coat?.inventory_category?.inventories[0]?.image}`
                                                                    : "/assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Coat:</span> {coat?.style ? coat?.style : "N/A"} {coat?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Size:</span> {coat?.size ? coat.size : "N/A"}
                                                                            {coat?.size_chart_category?.name
                                                                                ? coat.size_chart_category.name === "Short"
                                                                                    ? "S"
                                                                                    : coat.size_chart_category.name === "Long"
                                                                                        ? "L"
                                                                                        : coat.size_chart_category.name === "Extra Long"
                                                                                            ? "X"
                                                                                            : coat.size_chart_category.name === "Regular"
                                                                                                ? "R"
                                                                                                : coat.size_chart_category.name === "Boys"
                                                                                                    ? "B"
                                                                                                    : "N/A"
                                                                                : ""}
                                                                        </li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>}

                                            {
                                                pant &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={pant?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${pant?.inventory_category?.inventories[0]?.image}`
                                                                    : "/assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Pant:</span> {pant?.style ? pant?.style : "N/A"} {pant?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Waist:</span> {pant?.size ? pant?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Outseam:</span> {pant?.outseam ? pant?.outseam : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Hip:</span> {pant?.hip ? pant?.hip : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                shirt &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={shirt?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${shirt?.inventory_category?.inventories[0]?.image}`
                                                                    : "/assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Shirt:</span> {shirt?.style ? shirt?.style : "N/A"} {shirt?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Size:</span> {shirtSize ? shirtSize : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Neck:</span> {shirt?.size ? shirt?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Sleeve:</span> {shirt?.sleeve ? shirt?.sleeve : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                vest &&
                                                <div className="eventDetailBox posRealtive">
                                                    <div className="row">
                                                        <div className="col-md-3 plNoneOrdr">
                                                            <Image
                                                                src={vest?.inventory_category?.inventories[0]?.image
                                                                    ? `${ImageUrl}${vest?.inventory_category?.inventories[0]?.image}`
                                                                    : "/assets/images/no-photo.png"}
                                                                className="selectCoatImgReview"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-md-9 pRNoneOrdr">
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Vest:</span> {vest?.style ? vest?.style : "N/A"} {vest?.inventory_category?.inventories[0]?.description}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                        <li className="coatInfoSize">
                                                                            <span>Size:</span> {vest?.size ? vest?.size : "N/A"}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {(tie || shoes || jewellery || pocketSquare) && (
                                                <>
                                                    <h5>Other detail</h5>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="othderDetailBox posRealtive">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        {tie && (
                                                                            <ul className="fstCategory-shirt">
                                                                                <li className="whitTxtDetail">
                                                                                    <span>Tie:</span> {tie?.style ? tie?.style : "N/A"} {tie?.inventory_category?.inventories[0]?.description}
                                                                                </li>
                                                                                <li>
                                                                                    <span>Size:</span> {data?.order_for}
                                                                                </li>
                                                                            </ul>
                                                                        )}

                                                                        {shoes && (
                                                                            <ul className="fstCategory-shirt">
                                                                                <li className="whitTxtDetail">
                                                                                    <span>Shoe:</span> {shoes?.style ? shoes?.style : "N/A"} {shoes?.inventory_category?.inventories[0]?.description}
                                                                                </li>
                                                                                <li>
                                                                                    <span>Size:</span> {shoes?.size ? shoes?.size : "N/A"}
                                                                                </li>
                                                                            </ul>
                                                                        )}

                                                                        {jewellery && (
                                                                            <ul className="fstCategory-shirt">
                                                                                <li className="whitTxtDetail">
                                                                                    <span>Jewelry:</span> {jewellery?.style ? jewellery?.style : "N/A"} {jewellery?.inventory_category?.inventories[0]?.description}
                                                                                </li>
                                                                            </ul>
                                                                        )}

                                                                        {pocketSquare && (
                                                                            <ul className="fstCategory-shirt borderMarginNone">
                                                                                <li className="whitTxtDetail">
                                                                                    <span>Pocket Square:</span> {pocketSquare?.style ? pocketSquare?.style : "N/A"} {pocketSquare?.inventory_category?.inventories[0]?.description}
                                                                                </li>
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}


                                            <hr></hr>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <h5>Audit Log</h5>
                                                    <div className="table-responsive tableScroll" id="style-14">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Date/Time</th>
                                                                    <th scope="col">User Name</th>
                                                                    <th scope="col">Change Type</th>
                                                                    <th scope="col">Previous Value</th>
                                                                    <th scope="col">New Value</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {data?.logs?.length > 0 ? (
                                                                    data.logs.map((data) => (
                                                                        <tr key={data.id || data.createdAt}>
                                                                            <th scope="row">
                                                                                {moment(data?.createdAt).format("MMM D, YYYY, h:mm A")}
                                                                            </th>
                                                                            <td>{data?.user?.firstName} {data?.user?.lastName}</td>
                                                                            <td>{data?.change_type}</td>
                                                                            <td>{data?.previous_data ? (data.previous_data.includes('XL') ? data.previous_data.replace('XL', 'X') : data.previous_data) : "N/A"}</td>
                                                                            <td>{data?.new_data ? (data.new_data.includes('XL') ? data.new_data.replace('XL', 'X') : data.new_data) : "N/A"}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="5" className="text-center">    <div className="data-not-found">
                                                                            <em className="icon ni ni-info"></em>
                                                                            <p>No data available</p>
                                                                        </div></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" tabindex="-1" id="instructionModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Member </h5>
                            <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <em class="icon ni ni-cross-c"></em>
                            </a>
                        </div>
                        <div class="modal-body inputCardBox">
                            <div className="inputCardBox">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label>First Name <span className="text-red-500">*</span></label>
                                        <input type="text" placeholder="Enter first name" />
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label>Last Name <span className="text-red-500">*</span></label>
                                        <input type="text" placeholder="Enter last Name" />
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label>Wedding Role<span className="text-red-500">*</span></label>
                                        <select>
                                            <option value="">select role</option>
                                            <option value="Best Man">Best Man</option>
                                            <option value="Groomsmen">Groomsmen</option>
                                            <option value="Father">Father</option>
                                            <option value="Ring Bearer">Ring Bearer</option>
                                            <option value="Usher">Usher</option>
                                            <option value="Try on">Try on</option>
                                            <option value="Other">Other</option>
                                            <option value="Groom">Groom</option>

                                        </select>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label>Copy Grooman Style <span className="text-red-500">*</span></label>
                                        <select>
                                            <option value={""}>select style</option>
                                            <option value={"Yes"}>Yes</option>
                                            <option value={"No"}>No</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-md-4 mb-3">
                                        <button type="submit" class="addBtnCustomer">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container >

    )
}

export default WeddingOrderReview